import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import withProgress from 'core/components/progress/withProgress'
import Dropdown from 'core/elements/dropdown'
import useListAction from 'core/hooks/useListAction'
import useScopedPreferences from 'core/session/useScopedPreferences'
import { listServerGroups } from 'openstack/components/vms/server-groups/actions'
import { serverGroupsSelector } from 'openstack/components/vms/server-groups/selectors'

const AsyncDropdown = withProgress(Dropdown, { inline: true })

export default function ServerGroupsPicklist({
  disabled = false,
  name = 'serverGroups',
  label = 'Server Group',
  ...rest
}) {
  const { prefs } = useScopedPreferences()
  const { currentTenant } = prefs

  const { loading } = useListAction(listServerGroups)
  const data = useSelector(serverGroupsSelector)

  const options = useMemo(() => {
    return [
      { label: 'None', value: null },
      ...data.map((group) => {
        return {
          label: `${group.name} (${group.policy})`,
          value: group,
        }
      }),
    ]
  }, [data])

  return (
    <AsyncDropdown
      {...rest}
      name={name}
      label={label}
      compact={false}
      disabled={disabled}
      loading={loading}
      items={options}
    />
  )
}
